// extracted by mini-css-extract-plugin
export default {"container":"ButtonAction_Reject_container__oWbJj","label":"ButtonAction_Reject_label__5mGmG","icon":"ButtonAction_Reject_icon__PTJr4"};